import { User } from "../interfaces";
import { getCityNameByCode } from "../shared/util";

export class UsersAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get city() {
        return getCityNameByCode(this.value.city)?.municipio;
    }

    get state() {
        return getCityNameByCode(this.value.city)?.departamento;
    }

    adapt(): User {
        return {
            id : this.value.id,
            email: this.value.email,
            first_name: this.value.first_name,
            last_name: this.value.last_name,
            password: this.value.password,
            role: this.value?.role?.name,
            state: this.state || 'No definido',
            city: this.city || 'No definido',
            phone: this.value.phone || 'No definido',
        };
    }
}
